import React from 'react';
import { IconButton } from '@mui/material';
import PublishIcon from '@mui/icons-material/Publish'; // Icon for the Import Button
import { useDropzone } from 'react-dropzone'; // For file uploads

const StoryImport = ({ onValidContent, disabled }) => {
  // Handle file upload for enhancement
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'text/plain': ['.txt'],
      'application/json': ['.json'],
    }, // Accept text and JSON files
    onDrop: async (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();

      reader.onload = async () => {
        const fileContent = reader.result; // Read the file content as a string
        try {
          // Pass the string content directly to onValidContent
          onValidContent(fileContent);
        } catch (error) {
          console.error('Error parsing file:', error);
          alert('Invalid file format. Please upload a valid text or JSON file.');
        }
      };

      reader.readAsText(file); // Read the file as text
    },
  });

  return (
    <IconButton
      color="primary"
      {...getRootProps()} // Dropzone props
      disabled={disabled} // Disable button while enhancing
      sx={{
        backgroundColor: '#007bff', // Blue background
        color: 'grey', // White icon
        '&:hover': {
          backgroundColor: '#0056b3', // Darker blue on hover
        },
      }}
    >
      <input {...getInputProps()} /> {/* Hidden file input */}
      <PublishIcon /> {/* Icon for the Import Button */}
    </IconButton>
  );
};

export default StoryImport;